/**
 * Progress of one course in a learner's Moodle profile snapshot
 * (`profile.moodle.enrollments[]`, written by al-tutor
 * moodle_learner_profile_sync): the Completion Progress bars when the Moodle
 * connection measures with them (`progress.source`), else the course
 * completion. No fallback between the two (PRD lms-progress-sources D1).
 * Plain text for a table cell; `—` when there is no number.
 */
export function moodleCourseProgressText(course: any, completedLabel: string): string {
  const progress = course?.progress;
  if (progress?.source === 'completion_progress') {
    const bars = (progress.trackers || []).filter(
      (t: any) => typeof t?.percentage === 'number'
    );
    if (!bars.length) return '—';
    return bars
      .map((t: any) => (t.title ? `${t.title}: ` : '') + `${Math.round(t.percentage)} %`)
      .join(' · ');
  }
  if (course?.completion_state === 'completed') return completedLabel;
  const pct = course?.completion_percent;
  return typeof pct === 'number' ? `${Math.round(pct)} %` : '—';
}
